import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledFifteenSecBackIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.9881 1.70891C11.0129 1.28905 8.95539 1.5053 7.11057 2.32667C5.68167 2.96286 4.43717 3.93678 3.47947 5.15623L5.8437 5.15623C6.25791 5.15623 6.5937 5.49202 6.5937 5.90623C6.5937 6.32044 6.25791 6.65623 5.8437 6.65623L2.08009 6.65623C2.07231 6.65635 2.06451 6.65635 2.05671 6.65623L1.62495 6.65623C1.21074 6.65623 0.874948 6.32044 0.874948 5.90623L0.874948 1.21873C0.874948 0.804515 1.21074 0.468729 1.62495 0.468729C2.03916 0.468729 2.37495 0.804515 2.37495 1.21873L2.37495 4.13512C3.4725 2.7686 4.88455 1.6758 6.50047 0.956349C8.63466 0.00614276 11.0149 -0.244029 13.3 0.241688C15.5851 0.727406 17.6578 1.92408 19.221 3.66019C20.7842 5.3963 21.7577 7.58273 22.0019 9.9061C22.2461 12.2295 21.7485 14.5705 20.5804 16.5937C19.4123 18.6169 17.6337 20.2183 15.4995 21.1685C13.3653 22.1188 10.9851 22.3689 8.69996 21.8832C6.41484 21.3975 4.34215 20.2008 2.77895 18.4647C2.50178 18.1569 2.52664 17.6827 2.83446 17.4055C3.14228 17.1283 3.6165 17.1532 3.89366 17.461C5.24491 18.9617 7.03656 19.9961 9.01183 20.416C10.9871 20.8358 13.0446 20.6196 14.8894 19.7982C16.7342 18.9769 18.2717 17.5926 19.2814 15.8437C20.2911 14.0948 20.7212 12.0712 20.5101 10.0629C20.299 8.05456 19.4576 6.16459 18.1063 4.66389C16.7551 3.16318 14.9634 2.12877 12.9881 1.70891Z'
            />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}
    fill: ${p => p.theme.playerIconsColor};
    width: 23px;
    height: 23px;
`
